import { keyBy } from "@adsk/alloy-react-helpers";

import {
  CategoryDTO,
  parseCategory,
  parseStatus,
  StatusDTO,
  StatusSetAssignment,
} from "../../models";
import {
  parseSystem,
  SystemDTO,
  SystemWithCategoryAndStatus,
} from "../../models/systems";

const getParsedAssets = (
  systems: SystemDTO[],
  categories: CategoryDTO[],
  statuses: StatusDTO[],
  statusSetAssignments?: StatusSetAssignment[]
): SystemWithCategoryAndStatus[] => {
  const categoriesMap = keyBy(categories, "id");
  const statusesMap = keyBy(statuses, "id");
  const statusSetByCategory = keyBy(statusSetAssignments || [], "categoryId");

  return systems.map((system) => {
    const category = categoriesMap[system.categoryId];
    const status = statusesMap[system.statusId];
    const statusSetAssignment = statusSetByCategory[category?.id || ""];

    return {
      ...parseSystem(system),
      ...(category && {
        category: parseCategory({
          ...category,
          statusSetAssignment,
        }),
      }),
      ...(status && { status: parseStatus(status) }),
    };
  });
};

export default getParsedAssets;
